import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { func, number, bool } from 'prop-types'

import { isProd } from 'utils/environment'
import { ratingType, sceneType, ratingOptionsType } from 'models/propTypes'
import { ART_ITEM, FURNITURE_ITEM } from 'constants/renderItemTypes'
import * as ratingTypes from 'models/ratings/constants'
import { getRatingForSelectedScene, getIsFetching, getRatingOptions } from 'models/ratings/selectors'
import { getSelectedScene, getSelectedCompositionId } from 'models/compositions/selectors'
import { requestRatings, submitRating, requestRatingOptions } from 'models/ratings/actions'
import { clickPlaceRenderItem } from 'models/compositions/actions'
import { triggerCompositionLoad } from 'models/admin/actions'

import RatingPanelView from 'components/designSidepanel/RatingPanelView'

const RatingPanelViewContainer = ({
    rating,
    options,
    scene,
    submit,
    fetchRatings,
    fetchRatingOptions,
    isFetching,
    compositionId,
    onClickPlace,
    refreshComposition,
}) => {
    const onChange = (e, tagId, kind) => {
        if (scene) {
            const value = kind !== ratingTypes.NOTE ? e.target.value : null
            const note = kind === ratingTypes.NOTE ? e.target.value : null
            const id = rating[tagId] && rating[tagId].id

            if (!value && !note && !id) {
                // If no value and no id then we can't delete
                return
            }

            submit(scene.jobId, tagId, id, kind, value, note)
        }
    }
    useEffect(() => {
        if (scene) {
            fetchRatings(scene.jobId)
        }
        if (!options) {
            fetchRatingOptions()
        }
    }, [scene])

    const autoDecorate = () => {
        if (scene.hasFloor) {
            const furnIds = isProd ? [17667, 23792, 18678, 24853] : [9576, 15142, 5695, 20122]

            furnIds.forEach((id) => {
                onClickPlace(compositionId, id, { id, heading: 0, renderType: FURNITURE_ITEM })
            })
        }
        if (scene.hasWall) {
            const artId = isProd ? 126026 : 126575
            onClickPlace(compositionId, artId, {
                matteId: 10,
                frameId: 2,
                sizeId: 1,
                colorId: 1,
                customHeight: null,
                renderType: ART_ITEM,
            })
        }
        refreshComposition()
    }

    return (
        <RatingPanelView
            rating={rating}
            options={scene && scene.jobId && options}
            onChange={onChange}
            isFetching={isFetching}
            autoDecorate={autoDecorate}
        />
    )
}

RatingPanelViewContainer.defaultProps = {
    rating: {},
    scene: null,
    options: null,
}

RatingPanelViewContainer.propTypes = {
    rating: ratingType,
    options: ratingOptionsType,
    scene: sceneType,
    submit: func.isRequired,
    fetchRatings: func.isRequired,
    fetchRatingOptions: func.isRequired,
    isFetching: bool.isRequired,
    compositionId: number.isRequired,
    onClickPlace: func.isRequired,
    refreshComposition: func.isRequired,
}

const mapStateToProps = (state) => ({
    rating: getRatingForSelectedScene(state),
    scene: getSelectedScene(state),
    isFetching: getIsFetching(state),
    options: getRatingOptions(state),
    compositionId: getSelectedCompositionId(state),
})

const mapDispatchToProps = (dispatch) => ({
    submit: (...args) => dispatch(submitRating(...args)),
    fetchRatings: (jobId) => dispatch(requestRatings(jobId)),
    fetchRatingOptions: () => dispatch(requestRatingOptions()),
    onClickPlace: (...args) => dispatch(clickPlaceRenderItem(...args)),
    refreshComposition: () => dispatch(triggerCompositionLoad()),
})

export default connect(mapStateToProps, mapDispatchToProps)(RatingPanelViewContainer)
